<template>
    <a class="grid h-color-fuel-navy files__file-link" style="overflow-wrap:anywhere;white-space: normal;" :href="file.file_url || ''" @click.self="followLink">
      <div class="grid__col--1 h-no-padding h-center-align">
        <span aria-hidden="true" class="glyphicon glyphicon-cloud-download"></span>
      </div>
      <div class="grid__col--11 h-no-margin h-no-padding">{{ file.file_name }}</div>
    </a>
</template>

<script>
  export default {
    name: 'FileAttachment',
    props: ['file'],
    methods: {
      followLink(e) {
        e.stopPropagation();
      },
    },
  };
</script>
